import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TextField, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const Step2 = ({
  formData = {},
  setFormData,
  errors = {},
  setErrors,
  filtersOptions = { categories: [] },
}) => {
  const FileInput = styled('input')({
    display: 'none', // Hide default input
  });

  const { categories = [] } = filtersOptions;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      file: e.target.files[0],
    }));
  };

  return (
    <>
      <span className='top-text mb-25'>
        უნდა მიეთითოს დეტალური ინფორმაცია პროდუქტის შესახებ. აღნიშნული
        ინფორმაციის გამოყენება მოხდება პროდუქტის იდენტიფიცირებისათვის.
      </span>

      <div>
        <span>კატეგორია</span>
        <TextField
          select
          fullWidth
          className='mb-20-mt-10'
          label='აირჩიეთ'
          name='productCategory'
          value={formData.productCategory || ''} // fallback
          onChange={handleChange}
        >
          {categories.length > 0 ? (
            categories.map((cat) => (
              <MenuItem key={cat.value} value={cat.value}>
                {cat.label}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled value=''>
              Loading...
            </MenuItem>
          )}
        </TextField>
      </div>

      <div>
        <TextField
          fullWidth
          label='პროდუქტის დასახელება (სავალდებულოა)'
          name='productName'
          className='mb-20-mt-10'
          value={formData.productName}
          onChange={handleChange}
          error={!!errors.productName}
          helperText={errors.productName}
          required
        />
      </div>

      <div>
        <TextField
          fullWidth
          multiline
          className='mb-20-mt-10'
          rows={4}
          label='პროდუქტის აღწერა (სავალდებულოა)'
          name='productDescription'
          value={formData.productDescription}
          onChange={handleChange}
          error={!!errors.productDescription}
          helperText={errors.productDescription}
          required
        />
      </div>

      <div>
        <span>შესაძლებლობის შემთხვევაში მიუთითეთ ბრენდის დასახელება</span>
        <TextField
          fullWidth
          className='mb-20-mt-10'
          label='ბრენდის დასახელება'
          name='brandName'
          value={formData.brandName}
          onChange={handleChange}
        />
      </div>

      <div>
        <span className='db'>
          შესაძლებლობის შემთხვევაში მიუთითეთ წარმოების თარიღი
        </span>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            label='წარმოების თარიღი'
            inputFormat='DD/MM/YYYY'
            className='mb-20-mt-10'
            value={formData.productionDate}
            onChange={(date) =>
              setFormData({ ...formData, productionDate: date })
            }
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
        </LocalizationProvider>
      </div>

      <div>
        <span>შესაძლებლობის შემთხვევაში ატვირთეთ ფოტო ან დოკუმენტი.</span>
        <label htmlFor='file-upload'>
          <FileInput
            id='file-upload'
            className='mb-20-mt-10'
            type='file'
            accept='.jpg,.png,.pdf'
            onChange={handleFileChange}
          />
          <TextField
            fullWidth
            label='აირჩიეთ ფაილი'
            value={formData.file ? formData.file.name : ''}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <Button variant='contained' component='span'>
                  ატვირთვა
                </Button>
              ),
            }}
            margin='normal'
          />
        </label>
      </div>
    </>
  );
};

export default Step2;
